<template>
	<div id="app">
		<Header :banner-bg="currentBannerBg" :banner-text1="currentBannerText1" :banner-text2="currentBannerText2"></Header>
		<router-view></router-view> <!-- 路由出口 -->
    <Bottom></Bottom>
	</div>
</template>

<script>
	import Header from './components/Header.vue'
  import Bottom from "./components/Bottom.vue";

	export default {
		name: 'app',
		components: {
			Header,
      Bottom,
		},
		data() {
			return {
				currentBannerImage: '',
			};
		},
		computed: {
			// 根据路由动态设置banner  
			currentBannerBg() {
				const routeName = this.$route.name; // 假设你已经给路由设置了name属性  
				// 根据routeName来返回不同的banner图片，这里只是一个简单的示例  
				if (routeName === '首页') {
					return require('./assets/banner1@2x.png');
				}
        else if (routeName === '关于我们') {
					return require('./assets/banner2@2x.png');
				}
        else if (routeName === '产品中心') {
          return require('./assets/banner3@2x.png');
        }
        else if (routeName === 'ProductDetail') {
          return require('./assets/banner3@2x.png');
        }
        else if (routeName === '联系我们') {
          return require('./assets/banner7@2x.png');
        }
				// 默认banner  
				return this.defaultBannerBg;
				// console.log(this.message);

			},

			currentBannerText1() {
				// 根据当前路由名返回不同的 banner 文字  
				const routeName = this.$route.name;
				if (routeName === '首页') {
					return '辽宁思凯';
				}
        else if (routeName === '关于我们') {
          return '品牌';
        }
        else if (routeName === '产品中心') {
          return '产品';
        }
        else if (routeName === 'ProductDetail') {
          return '产品';
        }
        else if (routeName === '联系我们') {
					return '联系';
				}
				// 默认banner  
				return this.defaultBannerText;
			},
			currentBannerText2() {
				// 根据当前路由名返回不同的 banner 文字  
				const routeName = this.$route.name;
				if (routeName === '首页') {
					return '智慧能源管理服务商';
				}
        else if (routeName === '关于我们') {
					return '打造专业的能源管理供应商';
				}
        else if (routeName === '产品中心') {
          return '为客户提供更高价值的商品';
        }
        else if (routeName === 'ProductDetail') {
          return '为客户提供更高价值的商品';
        }
        else if (routeName === '联系我们') {
          return '深耕行业领域，打造产业格局';
        }
				// 默认banner  
				return this.defaultBannerText;
			}
		}

	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}

	ul {
		list-style: none;
    margin: 0;
    padding: 0;
	}
  li {
    margin: 0;
    padding: 0;
  }
  p {
    margin: 0;
    padding: 0;
  }
	#app {
		font-family: SourceHanSansCN, SourceHanSansCN, 'Avenir', Helvetica, Arial, sans-serif;

		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		width: 100%;
	}
</style>